import React, { useState } from 'react';
import { Layout, Menu, Drawer, Button, Row, Col } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { BrowserView, MobileView } from 'react-device-detect';

import _s from './Layouts.less';

const { Header, Footer, Content } = Layout;
const hideFooterOnPages = ['/', '/plans'];

const GuestLayout = props => {
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const selected = location.pathname ? '/' + location.pathname.split('/')[1] : null;

  return (
    <Layout className="layout" style={{ minHeight: '100vh', background: '#ffffff' }}>
      <Header className={_s.Header} style={{ background: '#ffffff', padding: '0 12px' }}>
        <MobileView>
          <Row justify="space-between">
            <Col>
              <Link to="/">
                <img src="/public/images/logo.png" alt="menu" className={_s.logo} />
              </Link>
            </Col>
            <Col>
              <Button type="default" onClick={showDrawer} icon={<MenuOutlined />} />
            </Col>
          </Row>
          <Drawer title="Menu" placement="right" onClose={onClose} visible={visible}>
            <Menu
              theme="light"
              mode="vertical"
              defaultSelectedKeys={['/']}
              selectedKeys={[props.location.pathname]}
            >
              <Menu.Item key="/plans">
                <Link to="/plans" style={{ fontWeight: '500' }}>
                  Plans
                </Link>
              </Menu.Item>
              <Menu.Item key="/login">
                <Link to="/login" onClick={onClose}>
                  Log In
                </Link>
              </Menu.Item>
            </Menu>
          </Drawer>
        </MobileView>
        <BrowserView>
          <Menu
            theme="light"
            mode="horizontal"
            defaultSelectedKeys={['/']}
            selectedKeys={[props.location.pathname]}
            style={{ lineHeight: '65px' }}
          >
            <Menu.Item key="logo">
              <Link to="/">
                <img src="/public/images/logo.png" alt="menu" className={_s.logo} />
              </Link>
            </Menu.Item>
            <Menu.Item key="/plans">
              <Link to="/plans" style={{ fontWeight: '500' }}>
                Plans
              </Link>
            </Menu.Item>
            <Menu.Item key="/login" className={_s.login}>
              <Link to="/login" style={{ fontWeight: '500' }}>
                Log In
              </Link>
            </Menu.Item>
          </Menu>
        </BrowserView>
      </Header>
      <Content className={_s.Content}>{props.children}</Content>
      {!hideFooterOnPages.includes(selected) && (
        <Footer style={{ textAlign: 'center' }}>© 2024 HomeWiP Inc.</Footer>
      )}
    </Layout>
  );
};

export default withRouter(GuestLayout);
